/**
 * Automation Module - Tasks Query Services
 *
 * Fetches cleaning automations from GET /api/Automations/GetAllAutomations.
 */

import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../../services/useApi';
import { GET_ALL_AUTOMATIONS_URL } from '../constants';
import type {
  IGetAllTasksParams,
  IGetAllTasksResponse,
  IGetAllAutomationsApiResponse,
} from '../types';

export const useGetAllTasks = (params: IGetAllTasksParams) => {
  const { apiPrivate } = useApi();

  return useQuery<IGetAllTasksResponse>({
    queryKey: [GET_ALL_AUTOMATIONS_URL, 'tasks', params.pageNumber, params.pageSize],
    queryFn: async () => {
      const { data } = await apiPrivate.get<IGetAllAutomationsApiResponse>(
        GET_ALL_AUTOMATIONS_URL,
        {
          params: {
            pageSize: params.pageSize,
            pageNumber: params.pageNumber,
            category: 'maintenance',
          },
        }
      );

      return {
        tasks: data.result?.automations ?? [],
        totalRecords: data.totalRecords ?? 0,
      };
    },
  });
};
